export default {
	app: {
		newVersionAvailable: "Nuova versione disponibile.",
		update: "Aggiorna",
	},
	header: {
		brand: "Zato Timbrature",
		development: "DEVELOPMENT",
		offline: "Sei offline",
	},
	home: {
		connectedAs: "Connesso come",
		logout: "Logout",
	},
	login: {
		title: "Login",
		username: "Username",
		password: "Password",
		submit: "Accedi",
		copyright: "Copyright © 2024 Servonet Srl - Versione beta",
	},
	dataSync: {
		title: "Sincronizzazione dati",
		loading: "Caricamento in corso...",
	},
	stampings: {
		order: "Commessa",
		users: "Utenti",
		traveling: "Viaggio",
		workType: "Tipologia di lavoro",
		notes: "Note",
		loading: "Loading...",
		start: "Avvia",
		stopSelected: "Ferma timbrature selezionate",
		tableUser: "Utente",
		tableTimer: "Timer",
		tableStart: "Inizio",
		tableEnd: "Fine",
		tableOrder: "Commessa",
		tableType: "Tipologia",
		tableWorkType: "Tipologia di lavoro",
		tableNotes: "Note",
		tableActions: "Azioni",
		typeTravel: "Viaggio",
		typeWork: "Lavoro",
		noItems: "Nessun elemento disponibile",
		unsyncedItems: "Timbrature non sincronizzate",
		alertOrderRequired: "La commessa deve essere obbligatoria",
		alertErrorOpen: "C'è stato un errore durante l'apertura della timbratura",
		alertDuplicateUser: "Non è possibile creare nuove timbrature per utenti che hanno già una timbratura aperta",
		alertErrorClose: "C'è stato un errore durante la chiusura della timbratura",
		alertErrorUpdate: "C'è stato un errore durante l'aggiornamento della timbratura",
	},
	errors: {
		offline: "Si è verificato un errore durante la richiesta; il dispositivo potrebbe essere offline.",
		generic: "Si è verificato un errore durante la richiesta.",
	},
}
